import RestService from '../services/rest';

async function getCategories() {
  return RestService.getAuthenticated('panel/categories');
}

async function createCategory(category) {
  return RestService.postAuthenticated('panel/categories/create', category);
}

async function removeCategory(id) {
  return RestService.postAuthenticated('panel/categories/delete', { id });
}

async function updateCategory(category) {
  return RestService.putAuthenticated('panel/categories/update', category);
}

async function updateCategories(categories) {
  return RestService.putAuthenticated('panel/categories/updateCategories', categories);
}

async function getCategoriesFeatured() {
  return RestService.getAuthenticated('panel/categories/is_featured');
}

async function uploadImage(file, id) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/categories/image?category=${id}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

async function uploadCsvCategories(file) {
  const fd = new FormData();
  fd.append('file', file);

  await RestService.postAuthenticated('panel/categories/import/csv', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function getCsvCategoriesModel() {
  const response = await RestService.getAuthenticated('panel/categories/model/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Categorias CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvCategoriesReport() {
  const response = await RestService.getAuthenticated('panel/categories/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'categories-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function updateCategoryStatus(categoryId) {
  return RestService.putAuthenticated('panel/categories/update/status', { category: categoryId });
}

export default {
  getCategories,
  createCategory,
  removeCategory,
  updateCategory,
  updateCategories,
  uploadImage,
  uploadCsvCategories,
  getCsvCategoriesModel,
  getCsvCategoriesReport,
  getCategoriesFeatured,
  updateCategoryStatus,
};
